import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { UserDataCDMS } from 'src/app/Interfaces/GeneralCDMS/User/User.interface';
import { Data_Token_CDMS, User_CDMS_Token } from 'src/app/Interfaces/Interfaces-Global/Data_Token_CDMS.interface';
import { Data_Cockie, User_Cockie } from 'src/app/Interfaces/Interfaces-Global/Data_Token_Cockie.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { CookieService } from 'src/app/Services/Global/Cookies/cookie.service';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-cdms',
  templateUrl: './login-cdms.component.html',
  styleUrls: ['./login-cdms.component.scss', '../../Styles/GlobalStyles.css'],
  standalone: false,
})
export class LoginCDMSComponent implements OnInit {

  //+================== VARIABLES FOR TOKEN AND USER ==================+\\

  private token: string | null = null
  private Data_User_Aux: string | null = null

  public loginName: string = '';
  public Password: string = '';
  public loginError: string = '';
  public isLoading: boolean = false;
  public showLoginForm: boolean = false;

  private UserService = inject(UserDataService);

  constructor(private GeneralCDMS: GeneralCDMSService, private router: Router, private cookieService: CookieService) {
    this.token = this.cookieService.getCookie('Token_COMPAS');
    this.Data_User_Aux = this.cookieService.getCookie('Data_User_COMPAS');
  }

  //+================== VARIABLES FOR SNAPSHOTS ==================+\\
  @Input('Key') Key: string = '';

  async ngOnInit(): Promise<void> {
    console.log('entrada ngOnInit');

    if (environment.production) {
      this.isLoading = true;
      this.CheckDataLogin();
    } else {
      this.showLoginForm = true;
    }
  }

  async onLogin(): Promise<void> {
    if (!this.loginName.trim() || !this.Password.trim()) return;
    this.loginError = '';
    this.isLoading = true;
    this.showLoginForm = false;
    await this.Check_User_In_DataBase(this.loginName.trim(), this.Password.trim(), this.Key || 'General/HomeSystemCDMS');
  }

  onForgotPassword(event: Event): void {
    event.preventDefault();
    this.router.navigate(['/forgot-password']);
  }
  private async CheckDataLogin() {
    try {

      //   if (this.token == null || this.Data_User_Aux == null) {
      //     localStorage.clear();
      //     window.location.href = 'http://localhost:4202'

      //   } else {

      //     const isValid = this.checkData();

      //     if (isValid) {

      //       const verifyTokenApi = await firstValueFrom(this.GeneralCDMS.VerifyToken({ token: this.token }));

      //       const isValidTokenApi: boolean = verifyTokenApi.operation;

      //       if (isValidTokenApi) {

      //         this.router.navigate([`/Dashboard/${this.Key}`])

      //       } else {

      //         const Data_User = JSON.parse((this.Data_User_Aux != null) ? `${this.Data_User_Aux}` : '');
      //         localStorage.setItem('token', (this.token != null) ? `${this.token}` : '');

      //         const LoginName: string = Data_User.LoginName;

      //         this.Check_User_In_DataBase(LoginName, this.Key)
      //       }


      //     } else {

      //       const Data_User = JSON.parse((this.Data_User_Aux != null) ? `${this.Data_User_Aux}` : '');
      //       localStorage.setItem('token', (this.token != null) ? `${this.token}` : '');

      //       const LoginName: string = Data_User.LoginName;

      //       this.Check_User_In_DataBase(LoginName, this.Key)

      //     }

      //   }



    } catch (e) {
      localStorage.clear();
      window.location.href = 'http://localhost:4202'
    }
  }

  private async Check_User_In_DataBase(LoginName: string, Password: string, Key: string) {

    try {

      const ResAuthentication: Response_CCP = await firstValueFrom(this.GeneralCDMS.Authentication_CDMS({ LoginName: LoginName, Password: Password }));


      if (ResAuthentication.success && ResAuthentication.operation.auth) {

        const DATA_Token = ResAuthentication.operation;
        const DATA_USER = DATA_Token.Data_User;

        const User_Data_CDMS: UserDataCDMS = { ID: DATA_USER.ID_DB, Name: DATA_USER.Name, Role: [], Library: [] }

        this.UserService.SetDataInfoUser(User_Data_CDMS);

        localStorage.setItem('token', DATA_Token.token);
        localStorage.setItem('ID_U_DB', DATA_USER.ID_DB);
        localStorage.setItem('Name_User', DATA_USER.Name);

        await new Promise((resolve) => setTimeout(resolve, 1000));

        this.router.navigate([`/Dashboard/${Key}`])

      } else {
        localStorage.clear();
        if (environment.production) {
          window.location.href = 'http://localhost:4202'
        } else {
          this.loginError = 'Usuario no encontrado o sin acceso';
          this.isLoading = false;
          this.showLoginForm = true;
        }
      }

    } catch (e) {
      console.log('enviamos a 404 not found');
      if (!environment.production) {
        this.loginError = 'Error de conexión con el servidor';
        this.isLoading = false;
        this.showLoginForm = true;
      }
    }
  }

  private checkData(): boolean {
    const tokenCOMPAS: string | null = this.cookieService.getCookie('Token_COMPAS');
    if (tokenCOMPAS === null) window.location.href = 'http://localhost:4202'
    const Data_Cockie: Data_Cockie = jwtDecode(tokenCOMPAS || '')
    const User_Cockie: User_Cockie = Data_Cockie.user

    const tokenCDMS = localStorage.getItem('token') || null;
    if (tokenCDMS === null) return false
    const Data_Token: Data_Token_CDMS = jwtDecode(tokenCDMS)
    const user_Token: User_CDMS_Token = Data_Token.user

    return user_Token.LoginName.trim().toUpperCase() === User_Cockie.LoginName.trim().toUpperCase()
  }

}